import { px, aRect, mRect, mPx } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const noses: Record<string, Part> = {
  nose_spike: {
    id: 'nose_spike',
    category: 'nose',
    name: 'Spike',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 4, 2, 4, p.metal); aRect(ctx, a.x, a.y - 5, 2, 1, p.metalDark); },
  },
  nose_sensor: {
    id: 'nose_sensor',
    category: 'nose',
    name: 'Sensor',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 2, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 2, 1, p.metal); aRect(ctx, a.x, a.y - 3, 2, 1, p.accent); },
  },
  nose_drill: {
    id: 'nose_drill',
    category: 'nose',
    name: 'Drill',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 5, 2, 5, p.metalDark); aRect(ctx, a.x, a.y - 4, 2, 1, p.metal); aRect(ctx, a.x, a.y - 2, 2, 1, p.metal); aRect(ctx, a.x, a.y, 2, 1, p.metal); aRect(ctx, a.x, a.y - 6, 2, 1, p.metalLight); },
  },
  nose_ram: {
    id: 'nose_ram',
    category: 'nose',
    name: 'Ram',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 2, 4, 2, p.metalDark); aRect(ctx, a.x, a.y - 3, 2, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 4, 1, p.metal); },
  },
  nose_antennae: {
    id: 'nose_antennae',
    category: 'nose',
    name: 'Antennae',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { mRect(ctx, 0, a.y - 4, 1, 4, p.metalDark); mPx(ctx, 0, a.y - 5, p.accent); },
  },
  nose_scoop: {
    id: 'nose_scoop',
    category: 'nose',
    name: 'Scoop',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 4, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 4, 1, p.metalDark); aRect(ctx, a.x, a.y - 3, 2, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 2, 1, p.dark); },
  },
  nose_headlight: {
    id: 'nose_headlight',
    category: 'nose',
    name: 'Headlight',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 2, 4, 2, p.metalDark); aRect(ctx, a.x, a.y - 2, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y - 1, 2, 1, p.exhaust); },
  },
  nose_lance: {
    id: 'nose_lance',
    category: 'nose',
    name: 'Lance',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 7, 2, 7, p.metal); aRect(ctx, a.x, a.y - 7, 2, 1, p.metalLight); aRect(ctx, a.x, a.y - 4, 2, 1, p.accent); aRect(ctx, a.x, a.y - 1, 2, 1, p.metalDark); },
  },
  nose_blade: {
    id: 'nose_blade',
    category: 'nose',
    name: 'Blade',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 8, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 6, 1, p.metalDark); aRect(ctx, a.x, a.y - 3, 4, 1, p.metalDark); aRect(ctx, a.x, a.y - 1, 6, 1, p.metal); },
  },
  nose_prong: {
    id: 'nose_prong',
    category: 'nose',
    name: 'Prong',
    requires: SLOT.NOSE,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 2, 1, p.metalDark); px(ctx, a.x - 2, a.y - 2, p.metal); px(ctx, a.x + 1, a.y - 2, p.metal); px(ctx, a.x - 2, a.y - 3, p.metalDark); px(ctx, a.x + 1, a.y - 3, p.metalDark); px(ctx, a.x - 2, a.y - 4, p.accent); px(ctx, a.x + 1, a.y - 4, p.accent); },
  },
};
